import React, { useState, useEffect, forwardRef } from "react";

// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Checkbox from '@mui/material/Checkbox';

// core components
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import GridItem from "components/Grid/GridItem.js";
import Loader from "components/Loader/Loader";
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

import moment from "moment";
import "moment/locale/es";

moment.locale("es");

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const useStyles = makeStyles(theme =>({
  ...styles,
  cardTitle: {
    marginTop: "0",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  },
  select: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    color: "#D2D2D2",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "1.42857",
    letterSpacing: "unset",
    "&:before": {
      borderColor: "#D2D2D2",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "1.42857",
      letterSpacing: "unset"
    },
    "&:after": {
      borderColor: "#D2D2D2",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "1.42857",
      letterSpacing: "unset"
    }
  },
  container: {
    textAlign: "center"
  },
  content: {
    display: "inline-flex",
    padding: "10px",
    alignItems: "center"
  },
  paddingBottomCard: {
    paddingBottom: "40px"
  },
  marginRight: {
    marginRight: "10px"
  },
  marginBottom: {
    marginBottom: "50px"
  },
  formControl: {
    marginTop: theme.spacing(3.5),
    minWidth: "100%"
  },
  formControl2: {
    minWidth: "100%",
    marginTop: theme.spacing(5)
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  }
}));

export default function Dashboard() {
  const classes = useStyles();

  const [ventas, setVentas] = useState([]);

  const [selectFechaInicio, setSelectedFechaInicio] = useState(new Date());
  const [selectFechaFin, setSelectedFechaFin] = useState(new Date());

  const [Semanal, setSemanal] = useState(0);
  const [Mensual, setMensual] = useState(0);

  const [color, setColor] = useState("");
  const [message, setMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const [load, setLoad] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  const sendSnackBar = (pmessage, pcolor) => {
    setOpenSnackbar(true);
    setColor(pcolor);
    setMessage(pmessage);
  };

  const Login = async () => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify({UserName: process.env.REACT_APP_USER, Password: process.env.REACT_APP_PASS}),
            headers: {
                "Content-Type": "application/json"
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Login",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const GetIdUsuario = () => {
    return JSON.parse(localStorage.getItem('userCalidad')).IdUsuario;
  };

  const ActualizaAceptacion = async (data, token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Calificacion/ActualizaAceptacion",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const ObtieneAceptadas = async (data, token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Calificacion/ObtieneAceptadas",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const ObtienePromediosEjecutivo = async (data, token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Calificacion/ObtienePromediosEjecutivo",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const limpiaValores = () => {
    setVentas([]);
    setSemanal(0);
    setMensual(0);
  };

  const handeSubmit = event => {
    event.preventDefault();
    try{
        setLoad(true);

        limpiaValores();

        let fechaInicio = moment(selectFechaInicio);
        fechaInicio.set({h: 0, m: 0, s: 0});

        let fechaFin = moment(selectFechaFin);
        fechaFin.set({h: 23, m: 59, s: 59});

        Login()
        .then(result => {
          let body = {
              FechaInicio: fechaInicio.format("YYYY/MM/DD HH:mm:ss"),
              FechaFin: fechaFin.format("YYYY/MM/DD HH:mm:ss"),
              Capturista: parseInt(GetIdUsuario())
          };

          ObtienePromediosEjecutivo(body, result.token)
          .then(result => {
            setSemanal(result.promediosEjecutivo.PromedioSemana);
            setMensual(result.promediosEjecutivo.PromedioMes);
            setLoad(false);
          }).catch(error => sendSnackBar("Error de conexión", "error"));

          ObtieneAceptadas(body, result.token)
          .then(result => {
            setVentas(result.aceptadas);
          }).catch(error => sendSnackBar("Error de conexión", "error"));
        }).catch(error => sendSnackBar("Error de conexión", "error"));
    } catch(error){
        sendSnackBar("Error de conexión", "error");
        setLoad(false);
    }
  };

  const handleChange = (event, id) => {
    let nVentas = [...ventas];
    
    nVentas[nVentas.findIndex(x => x.IdCaptura === id)].Aceptada = true;

    Login()
    .then(result => {
      let body = {
        IdCaptura: parseInt(id)
      };

      ActualizaAceptacion(body, result.token)
      .then(result => {
        sendSnackBar("Calificación aceptada", "success")
      }).catch(error => sendSnackBar("Error de conexión", "error"));
    }).catch(error => sendSnackBar("Error de conexión", "error"));    

    setVentas(nVentas);
  };

  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Grid className={classes.marginBottom}>
          <Grid container className={classes.paddingBottomCard}>
            <GridItem xs={12} sm={12} md={4}>
              <FormControl className={classes.formControl}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    format="yyyy/MM/dd"
                    label="Fecha inicio"
                    value={selectFechaInicio}
                    onChange={(date) => setSelectedFechaInicio(date)}
                    slotProps={{ textField: { fullWidth: true } }}
                    renderInput={(props) => <TextField {...props} />}
                  />
                </DemoContainer>
              </FormControl>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <FormControl className={classes.formControl}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    label="Fecha Final"
                    format="yyyy/MM/dd"
                    value={selectFechaFin}
                    onChange={(date) => setSelectedFechaFin(date)}
                    slotProps={{ textField: { fullWidth: true } }}
                    renderInput={(props) => <TextField {...props} />}
                  />
                </DemoContainer>
              </FormControl>
            </GridItem>
          </Grid>
          <Grid container spacing={3} style={{marginLeft: "1px"}}>
            <GridItem xs={12} sm={12} md={2}>
              <Button
                onClick={e => {
                  handeSubmit(e);
                }}
                color="info"
              >
                Buscar
              </Button>
            </GridItem>
          </Grid>
        </Grid>
      </LocalizationProvider>
      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader stats icon>
              <p className={classes.cardCategory}>Promedio calificación semanal</p>
              <h3 className={classes.cardTitle} style={{color: "black"}}>{Semanal}</h3>
            </CardHeader>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader stats icon>
              <p className={classes.cardCategory}>Promedio calificación mensual</p>
              <h3 className={classes.cardTitle} style={{color: "black"}}>{Mensual}</h3>
            </CardHeader>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <Card style={{ marginBottom: "30px" }}>
            <Grid container spacing={3} style={{ padding: "30px" }}>
                <Grid item xs={12} sm={12} xl={12}>
                    <Typography variant="h6">
                        Ventas
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={4} xl={4}>
                    <Typography variant="subtitle1">Folio</Typography>
                </Grid>
                <Grid item xs={12} sm={4} xl={4}>
                    <Typography variant="subtitle1">Observación</Typography>
                </Grid>
                <Grid item xs={12} sm={2} xl={2} style={{display: "flex"}}>
                    <Typography variant="subtitle1" style={{margin: "auto"}}>
                        Calificación
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={2} xl={2} style={{display: "flex"}}>
                    <Typography variant="subtitle1" style={{margin: "auto"}}>
                        Validación
                    </Typography>
                </Grid>
                {ventas.map((column) => (
                    <Grid item xs={12} sm={12} xl={12} key={column.IdPreguntas}>
                        <Grid container>
                            <Grid item xs={12} sm={4} xl={4} style={{borderColor: "#2196F3", display: "flex", backgroundColor: "#c1e1ec", borderLeft: "6px solid #2196F3", padding: "10px"}}>
                                <Typography variant="body1" style={{color: "black", margin: "auto" }}>{column.Folio}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={4} xl={4} style={{borderColor: "#2196F3", display: "flex", backgroundColor: "#c1e1ec" }}>
                                <Typography variant="body1" style={{color: "black", margin: "auto" }}>{column.Observacion}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={2} xl={2} style={{backgroundColor: "#d4ebf2", display: "flex"}}>
                              <Typography variant="body1" style={{color: "black", margin: "auto" }}>{column.Calificacion}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={2} xl={2} style={{backgroundColor: "#d3f8d3", display: "flex"}}>
                                <Checkbox 
                                    onChange={(event) => handleChange(event, column.IdCaptura)} 
                                    checked={ventas.find(x => x.IdCaptura === column.IdCaptura).Aceptada} 
                                    icon={<CheckCircleOutlineIcon />} 
                                    checkedIcon={<CheckCircleIcon color='green' />}
                                    style={{ margin: "auto" }}
                                    color="success"
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                ))}
              </Grid>
          </Card>
        </GridItem>
      </GridContainer>
      <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "right" }} open={openSnackbar} onClose={handleClose} autoHideDuration={6000}>
            <Alert onClose={handleClose} severity={color} sx={{ width: '100%' }}>
                {message}
            </Alert>
      </Snackbar>
      <Loader load={load} />
    </div>
  );
}